import script from "./UpdateProcedureTypes.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateProcedureTypes.vue?vue&type=script&setup=true&lang=js"

import "./UpdateProcedureTypes.vue?vue&type=style&index=0&id=e25de66a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e25de66a"]])

export default __exports__